import * as React from 'react';
import InvAmount from '../Controls/InvAmount/InvAmount';
import OnboardNote from '../OnboardNote/OnboardNote';
import Why from './Why';
import amountIllustration from '../../assets/images/amount-illustration.svg';

interface WalkthroughFundsProps {
  lumpSum: number;
  monthlyContribution: number;
  setMonthlyContribution: (x: number) => object;
  setLumpSum: (x: number) => object;
  next: () => void
  previous: () => void
  skip: () => void
}

const truncated = () => (<h2>What are you working with?</h2>);
const expanded = () => (
  <div>
    <p>Do you have a single, larger sum of money from a bonus, tax refund or inheritance? This is a good chance to make that money work for you by kickstarting a nest egg.</p>
    <p>Can you make space in your monthly budget to prioritise long-term investment? Remember, saving is paying yourself instead of only paying other people.</p>
    <p>Of course you can always do both.</p>
  </div>
);

class WalkthroughFunds extends React.Component<WalkthroughFundsProps> {
  public render () {
    return (
      <div className='walkthrough-steps'>
        <Why
          illustration={amountIllustration}
          colour='blue'
          next={this.props.next}
          skip={this.props.skip}
          truncated={truncated()}
          expanded={expanded()} />
        <div className='walkthrough-how'>
          <div className='how-inner'>
            <div className='note-wrap'>
              <OnboardNote positionX='left' positionY='top'>
                <p>This is a once off payment to kick off your investment</p>
              </OnboardNote>
            </div>
            <InvAmount
              lumpSum={this.props.lumpSum}
              monthlyContribution={this.props.monthlyContribution}
              setLumpSum={this.props.setLumpSum}
              setMonthlyContribution={this.props.setMonthlyContribution}
            />
            <div className='note-wrap'>
              <OnboardNote positionX='right' positionY='bottom'>
                <p>You can top up your investment by adding to it each month</p>
              </OnboardNote>
            </div>
            <button
              disabled={!this.props.next}
              onClick={this.props.next}
              className='button primary-button'
            >
              Confirm amounts
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default WalkthroughFunds;
